export default __webpack_public_path__ + "static/media/12.a2ae3988.png";